import script from "./UReportMiniature.vue?vue&type=script&setup=true&lang=ts"
export * from "./UReportMiniature.vue?vue&type=script&setup=true&lang=ts"

import "./UReportMiniature.vue?vue&type=style&index=0&id=399569b4&lang=css"

const __exports__ = script;

export default __exports__